import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgxSkeletonModule } from 'ngx-skeleton';
import { SlickCarouselModule } from 'ngx-slick-carousel';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from '../shared/shared.module';
import { NgSelectModule } from '@ng-select/ng-select';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { NgxSliderModule } from '@angular-slider/ngx-slider';
import { MatDialogModule } from '@angular/material/dialog';
import { RouterModule, Routes } from '@angular/router';
import { NewAdvanceSearchComponent } from './new-advance-search/new-advance-search.component';
import { NewbrtCalculatorComponent } from './newbrt-calculator/newbrt-calculator.component';
import { SearchComponent } from './search/search.component';
import { VehicleMappingComponent } from './vehicle-mapping/vehicle-mapping.component';
import { AdvanceVehicleListComponent } from './advance-vehicle-list/advance-vehicle-list.component';
import { AdvanceSmartSelectComponent } from './advance-smart-select/advance-smart-select.component';
import { AdvanceFilterComponent } from './advance-filter/advance-filter.component';
import { AdvanceproductlistComponent } from './advanceproductlist/advanceproductlist.component';
import { AdvanceHeaderComponent } from './advance-header/advance-header.component';
import { NewAdvanceSearchHeaderComponent } from './new-advance-search-header/new-advance-search-header.component';
import { AuthGuard } from '../shared/services/auth/auth.guard';




const routes: Routes = [
  // {
  //   path: 'advancesearch',
  //   component:NewAdvanceSearchComponent,
  // },
  {
    path: 'advancesearch',
    canActivate:[AuthGuard],
    component: SearchComponent,
  },

  {
    path: 'advancesearch/:search/:level1',
    component: VehicleMappingComponent
  },
  {
    path:'advancesearch/:search/:level1/:level2',
    component:AdvanceVehicleListComponent
  },
  {
    path:'advancesearch/:search/:level1/:level2/:level2name/:level3/:vcnumber',
    component:AdvanceSmartSelectComponent
  },
  {
    path:'advancesearch/:search/:level1/:level2/:level2name/:level3/:vcnumber/:smart-filter',
    component:AdvanceFilterComponent
  },
  {
    path:'advancesearch/:search/:level1/:level2/:level2name/:level3/:vcnumber/:smart-filter/:plp-list',
    component:AdvanceproductlistComponent
  },

];

@NgModule({
  declarations: [
    NewAdvanceSearchComponent,
    NewAdvanceSearchHeaderComponent,
    NewbrtCalculatorComponent,
    SearchComponent,
    VehicleMappingComponent,
    AdvanceVehicleListComponent,
    AdvanceSmartSelectComponent,
    AdvanceFilterComponent,
    AdvanceproductlistComponent,
    AdvanceHeaderComponent,

  ],
  imports: [
    CommonModule,
    NgxSkeletonModule,
    SlickCarouselModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    NgSelectModule,
    CarouselModule,
    NgxSliderModule,
    MatDialogModule,
    RouterModule.forChild(routes)
  ]
})
export class NewAdvanceSearchModule { }
